module.exports = __webpack_public_path__ + "static/media/maximizeIcon.a856e4a6.svg";